import TextInput, { type TextInputProps } from './TextInput';

/**
 * Multi-line text: TextInput with `multiline`. `rows` (default 3) sets the
 * visible lines; longer text scrolls inside the field.
 *
 * onValueChanged fires only for user changes, never when `value` changes.
 */
export type TextAreaProps = Omit<TextInputProps, 'multiline' | 'mode' | 'showClearButton'>;

export default function TextArea(props: TextAreaProps) {
  return <TextInput {...props} multiline />;
}
